import { useEffect, useState } from 'react'

import type { MyTicketDetailModel } from '@/components/myTicket/model'

import type { ShareAbleTime } from '@/api/client/purchase/dto/purchaseDto'
import Shared from '@/shared'

import { getShareTicketExtendDailyAbleTime, requestAuthGuest } from '@/api/client/purchase'

export interface ExtendParkinglotEnteringTimeViewModel {
  texts: object
  states: {
    extendTime: ShareAbleTime['usingTime']
    price: ShareAbleTime['price']
    time: ShareAbleTime[]
    selectedIndex: number | null
    isSharedNoticeOpen: boolean
    endTime: string
    isConfirmOpen: boolean
  }
  setters: object
  handlers: {
    handleEnteringTimeValue: (index: number) => void
    handleSharedNoticeOpen: () => void
    onClickTimeNextBtn: () => void
    onClickHeaderBackBtn: () => void
    showPurchaseInfo: () => void
    closePurchaseInfo: () => void
  }
}

const useExtendParkinglotEnteringTimeViewModel = (data: MyTicketDetailModel): ExtendParkinglotEnteringTimeViewModel => {
  const setStep = Shared.States.usePurchaseStep((state) => state.setPurchaseStep)
  const [extendTime, setExtendTime] = useState<ShareAbleTime['usingTime']>(0)
  const [price, setPrice] = useState<ShareAbleTime['price']>(0)
  const [time, setTime] = useState<ShareAbleTime[]>([])
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null)
  const [isSharedNoticeOpen, setIsSharedNoticeOpen] = useState(false)
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const { guestSeq } = Shared.States.useStorageStore()

  useEffect(() => {
    handleAbleTimes()
  }, [])

  const endTime = String(data.ticket.share?.endTime)

  const handleAbleTimes = async () => {
    if (!data) return
    const authPayload = {
      guestSeq: guestSeq
    }
    const { data: auth } = await requestAuthGuest(authPayload)
    const { data: timeData } = await getShareTicketExtendDailyAbleTime(
      { seq: Number(data.parkinglot.seq), endTime: data.ticket.share?.endTime },
      auth
    )
    setTime(
      timeData.times.map((item: ShareAbleTime) => {
        return {
          usingTime: item.usingTime,
          price: item.price
        }
      })
    )
  }

  const handleEnteringTimeValue = (index: number) => {
    if (!time) return
    setSelectedIndex(index)
    setExtendTime(time[index].usingTime)
    setPrice(time[index].price)
  }

  const handleSharedNoticeOpen = () => {
    if (extendTime) return
    setIsSharedNoticeOpen((prev) => !prev)
  }

  const showPurchaseInfo = () => {
    setStep(2)
  }

  const closePurchaseInfo = () => {
    setIsConfirmOpen((prev) => !prev)
  }

  const onClickTimeNextBtn = () => {
    setIsConfirmOpen(true)
  }

  const onClickHeaderBackBtn = () => {
    setStep(0)
  }

  return {
    texts: {},
    states: {
      time,
      selectedIndex,
      extendTime,
      price,
      isSharedNoticeOpen,
      endTime,
      isConfirmOpen
    },
    setters: {},
    handlers: {
      handleEnteringTimeValue,
      handleSharedNoticeOpen,
      onClickTimeNextBtn,
      onClickHeaderBackBtn,
      showPurchaseInfo,
      closePurchaseInfo
    }
  }
}

export default useExtendParkinglotEnteringTimeViewModel
